import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const Content = styled.div `
  display: flex;
  justify-content: space-between;
  min-height: 40px;
`;
export const TitleContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-50);
`;
export const Title = styled.div `
  display: flex;
  align-items: center;
  gap: var(--space-200);
  font-size: var(--font-size-400);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-400); /* 150% */
  letter-spacing: var(--font-letter-spacing-normal);
`;
export const Icon = styled.div `
  width: 16px;
  height: 16px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
export const Subtitle = styled.div `
  color: var(--text-secondary);
  font-family: var(--font-family-body);
  font-size: var(--font-size-300);
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-300); /* 142.857% */
  letter-spacing: var(--font-letter-spacing-loose);
`;
export const ValueContainer = styled.div `
  display: flex;
  gap: var(--space-300);
  align-items: center;
`;
export const Value = styled.div `
  display: flex;
  font-family: var(--font-family-heading);
  font-size: var(--font-size-700);
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-600); /* 112.5% */
  letter-spacing: var(--font-letter-spacing-densest);
  min-height: 16px;
`;
